/* eslint-disable max-len */
if (document.getElementById('score-board')) {
  import('./modules/scoresApp').then(({ default: scoresApp }) => {
    scoresApp.init();
  }).catch(() => 'An error occurred while loading the component scoresApp');
}
if (window.parent.document.getElementById('theIframe')) {
  import('./modules/the-iframe').then(({ default: theIframe }) => {
    theIframe.init();
  }).catch(() => 'An error occurred while loading the component theIframe');
}
if (document.getElementsByClassName('clickable').length) {
  import('./modules/clickable').then(({ default: clickable }) => {
    clickable.init();
  }).catch(() => 'An error occurred while loading the component clickable');
}
if (document.getElementsByClassName('main-navigation-container').length) {
  import('./modules/main-navigation').then(({ default: mainNavigation }) => {
    mainNavigation.init();
  }).catch(() => 'An error occurred while loading the component navigation');
}
if (document.getElementsByClassName('responsive-image').length) {
  import('./modules/responsive-images').then(({ default: responsiveImages }) => {
    responsiveImages.init();
  }).catch(() => 'An error occurred while loading the component responsiveImages');
}
if (document.getElementsByClassName('photo-rotator').length) {
  import('./modules/photo-rotator').then(({ default: photoRotator }) => {
    photoRotator.init();
  }).catch(() => 'An error occurred while loading the component photoRotator');
}
if (document.getElementById('footer-content') && document.getElementById('main-container') && document.getElementById('footer-container')) {
  import('./modules/sticky-footer').then(({ default: stickyFooter }) => {
    stickyFooter.init();
  }).catch(() => 'An error occurred while loading the component stickyFooter');
}
if (document.getElementsByClassName('doForm').length > 0) {
  import('./modules/form').then(({ default: form }) => {
    form.init();
  }).catch(() => 'An error occurred while loading the component form');
}
if (document.getElementsByClassName('countdown').length) {
  import('./modules/countdown').then(({ default: countdown }) => {
    countdown.init();
  }).catch(() => 'An error occurred while loading the component countdown');
}
if (document.querySelector('input.duplicate')) {
  import('./modules/duplicate').then(({ default: duplicate }) => {
    duplicate.init();
  }).catch(() => 'An error occurred while loading the component duplicate');
}
if (document.querySelector('a[role="tab"]')) {
  import('./modules/tab').then(({ default: tab }) => {
    tab.init();
  }).catch(() => 'An error occurred while loading the component tab');
}
const eqh = document.querySelectorAll('[data-equalheight]');
if (eqh.length) {
  import('./modules/equal-height').then(({ default: equalHeight }) => {
    equalHeight.init(eqh);
  }).catch(() => 'An error occurred while loading the component equalHeight');
}
import('./modules/remove-empty-paragraphs').then(({ default: removeEmptyParagraphs }) => {
  removeEmptyParagraphs.init();
}).catch(() => 'An error occurred while loading the component removeEmptyParagraphs');
import('./modules/posts').then(({ default: posts }) => {
  posts.init();
}).catch(() => 'An error occurred while loading the component posts');
import('./modules/links').then(({ default: links }) => {
  links.init();
}).catch((_error) => 'An error occurred while loading the component links');
if (document.getElementsByClassName('toForm')) {
  import('./modules/filterForm').then(({ default: filterForm }) => {
    filterForm.init();
  }).catch(() => 'An error occurred while loading the component filterForm');
}
if (document.getElementById('gzg-cosplay')) {
  import('./modules/cosplay')
    .catch(() => 'An error occurred while loading the component cosplay');
}
if (document.getElementsByClassName('v-collapse')) {
  import('./modules/collapse');
}
if (document.getElementById('v-photo-gallery')) {
  import('./modules/photo-gallery')
    .catch(() => 'An error occurred while loading the component photoGallery');
}

if (document.getElementsByClassName('video-background--container').length > 0) {
  import('./modules/VideoBackground').then(({ default: VideoBackground }) => {
    VideoBackground.init();
  }).catch(() => 'An error occurred while loading the component VideoBackground');
}
